<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>manage-apps</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">manage-apps</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content>
